export const TowerEvents = {
  FloorCleared: "tower-floor-cleared",
  BattleEnded: "tower-battle-ended",
  PlayerDowned: "tower-player-downed",
  ReviveAccepted: "tower-revive-accepted",
  BattleGiveUp: "tower-battle-give-up",
  AutoChaseChanged: "tower-auto-chase-changed",
  PlayerHpChanged: "tower-player-hp-changed",
  PlayerManaChanged: "tower-player-mana-changed",
  FocusTargetChanged: "tower-focus-target-changed",
  /** Fired when an enemy dies in TowerScene (battle only; not home). */
  EnemyDefeated: "tower-enemy-defeated",
  HealthPotionHeal: "tower-health-potion-heal",
  /** Battle skill rejected (range, buff active, etc.) — HUD should roll back slot cooldown. */
  SkillUseRejected: "tower-skill-use-rejected",
  /** Skill cast succeeded — HUD applies chain GCD on other slots. */
  SkillUseAccepted: "tower-skill-use-accepted",
} as const;

export type TowerFloorClearedPayload = {
  floor: number;
  baseXp: number;
  enemiesKilled?: number;
};

export type TowerBattleEndedPayload = {
  floor: number;
  victory: boolean;
  /** Left the floor via surrender (not knocked out). */
  surrendered?: boolean;
};

export type TowerPlayerDownedPayload = {
  floor: number;
};

export type TowerAutoChasePayload = {
  enabled: boolean;
};

export type TowerPlayerHpChangedPayload = {
  current: number;
  max: number;
  /** Damage taken this tick (0 on heal/full sync). */
  damageTaken: number;
};

export type TowerPlayerManaChangedPayload = {
  current: number;
  max: number;
};

export type TowerFocusTargetSnapshot = {
  name: string;
  imageDataUrl: string;
  currentHp: number;
  maxHp: number;
};

export type TowerFocusTargetChangedPayload = {
  target: TowerFocusTargetSnapshot | null;
  /** Damage dealt to focus this tick (0 when target changes or clears). */
  damageTaken: number;
};

export type TowerHealthPotionHealPayload = {
  amount: number;
};

export type TowerSkillUseRejectedPayload = {
  slotIndex: number;
};

export type TowerSkillUseAcceptedPayload = {
  slotIndex: number;
  chainGcdMs: number;
};
